import * as React from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fab from "@mui/material/Fab";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  addWeeks,
  compareAsc,
  endOfWeek,
  startOfWeek,
  subWeeks
} from "date-fns";

import { getDateRangeString } from "./utils";

type StaffAvailabilityHeaderProps = {
  fromDate: Date;
  setFromDate: React.Dispatch<React.SetStateAction<Date>>;
  showFilter: boolean;
  setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function StaffAvailabilityHeader({
  fromDate,
  setFromDate,
  showFilter,
  setShowFilter
}: StaffAvailabilityHeaderProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("mobile"));

  return (
    <Stack
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 1 }}
    >
      <Typography
        fontWeight={700}
        color={theme.palette.staffAvailabilityHeader.headerColor}
        lineHeight="1.5"
      >
        {!isMobile ? "Showing" : ""} Availability For Week Of
      </Typography>
      <Stack flexDirection="row" alignItems="center" mr={-2}>
        <IconButton
          color="primary"
          disabled={compareAsc(fromDate, startOfWeek(new Date())) === 0}
          onClick={() => setFromDate(subWeeks(fromDate, 1))}
          data-testid="prev-availability-week"
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
        <Typography
          color={theme.palette.staffAvailabilityHeader.color}
          border={1}
          padding={1}
          paddingLeft={2}
          paddingRight={2}
          borderColor={theme.palette.staffAvailabilityHeader.bgcolor}
        >
          {getDateRangeString(fromDate, endOfWeek(fromDate))}
        </Typography>
        <IconButton
          color="primary"
          onClick={() => setFromDate(addWeeks(fromDate, 1))}
          data-testid="next-availability-week"
          sx={{ background: "none !important" }}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </Stack>
      <Fab
        onClick={() => setShowFilter((prev) => !prev)}
        size="small"
        sx={{
          minHeight: "2rem",
          height: "2rem",
          width: "2rem",
          backgroundColor: "#fff",
          border: `solid 1px ${theme.palette.primary.main}`
        }}
        data-testid="expand-availability-filters"
      >
        {showFilter ? (
          <KeyboardArrowUpIcon sx={{ color: theme.palette.primary.main }} />
        ) : (
          <KeyboardArrowDownIcon sx={{ color: theme.palette.primary.main }} />
        )}
      </Fab>
    </Stack>
  );
}
